import {
  FETCH_AUDIT_TRAILS_START,
  FETCH_AUDIT_TRAILS_SUCCESS,
  FETCH_AUDIT_TRAILS_FAIL,
  REINIT_AUDIT_TRAILS,
} from "../constants";
import { updateObject } from "./utility";

const initialState = {
  auditTrails: [],
  loading: false,
  total: 0,
};

const auditTrailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REINIT_AUDIT_TRAILS:
      return updateObject(state, initialState);
    case FETCH_AUDIT_TRAILS_START:
      return updateObject(state, { loading: true });
    case FETCH_AUDIT_TRAILS_SUCCESS:
      return updateObject(state, {
        auditTrails: action.data,
        total: action.total,
      });
    case FETCH_AUDIT_TRAILS_FAIL:
      return updateObject(state, { loading: false });

    default:
      return state;
  }
};

export default auditTrailsReducer;
